import React from 'react';
import PropTypes from 'prop-types';
import { Text, Link } from '@comicrelief/component-library';

const Failure = ({ paymentFailure, url, submissionFailureResponse = null }) => {
  if (paymentFailure) {
    return (
      <div data-test="prize-payment-failure">
        <Text tag="p" size="m">
          Oops, your payment didn&apos;t go through
        </Text>
        <Text tag="p" weight="bold" size="s">
          Your transaction failed and you&apos;ve not been charged
        </Text>
        <Link
          href={url}
          target="self"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = url;
          }}
        >
          Try again
        </Link>
      </div>
    );
  }

  // Else, handle the different scenarios appropriately:
  let thisError;

  // I've broken this out into if/else logic to allow
  // easy extension for other scenarios/error messages.
  //
  // In an ideal world, we'd have unique error codes we could use...
  // (https://github.com/comicrelief/serverless-prize-platform/blob/068cac7bc670cc5f82f10dbbe11cc28058838ab0/src/Errors/DailyEntryLimitExceeded.js)

  if (submissionFailureResponse?.includes('Daily ticket limit')) {
    thisError = 'This entry takes you over your daily entry limit. Please select another amount or try again tomorrow. This entry has not been counted.';
  } else {
    thisError = 'Oops!  We are having some technical difficulties, please check back later.';
  }
  return (
    <div data-test="prize-submission-failure">
      <Text tag="p" size="m">
        { thisError}
      </Text>
    </div>
  );
};

Failure.propTypes = {
  paymentFailure: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  submissionFailureResponse: PropTypes.string
};

export default Failure;
